import CitySEOHead from "@/components/feature/CitySEOHead";
import MurfreesboroHeroSection from "./components/HeroSection";
import MurfreesboroStickyNav from "./components/StickyNav";
import MurfreesboroProcessingTimeSection from "./components/ProcessingTimeSection";
import MurfreesboroServicesSection from "./components/ServicesSection";
import MurfreesboroLocalAreaSection from "./components/LocalAreaSection";
import MurfreesboroTravelTimingSection from "./components/TravelTimingSection";
import MurfreesboroDestinationsSection from "./components/DestinationsSection";
import MurfreesboroTestimonialsSection from "./components/TestimonialsSection";
import MurfreesboroAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MurfreesboroComparisonSection from "./components/ComparisonSection";
import MurfreesboroMistakesSection from "./components/MistakesSection";
import MurfreesboroHowItWorksSection from "./components/HowItWorksSection";
import MurfreesboroFAQSection, { faqs } from "./components/FAQSection";
import MurfreesboroHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MurfreesboroFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport Murfreesboro TN", description: "Urgent passport processing for Murfreesboro and Rutherford County travelers with immediate international departure needs, as fast as 24 hours." },
  { name: "Expedited Passport Renewal Murfreesboro TN", description: "Fast passport renewal for MTSU students, Nissan Smyrna employees, and Rutherford County residents — 2-9 business days." },
  { name: "New Passport Murfreesboro TN", description: "First-time passport application assistance for Murfreesboro-area residents with acceptance facility scheduling support." },
  { name: "Child Passport Murfreesboro TN", description: "Minor passport services for Rutherford County families, with parental consent guidance and step-by-step acceptance clerk support." },
  { name: "Lost Stolen Passport Replacement Murfreesboro TN", description: "Fast replacement of lost or stolen passports for Murfreesboro and Rutherford County residents." },
  { name: "MTSU Study Abroad Passport Murfreesboro TN", description: "Expedited passport processing for Middle Tennessee State University students with study-abroad program deadlines." },
];

export default function MurfreesboroPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Murfreesboro"
        state="Tennessee"
        stateAbbr="TN"
        route="/murfreesboro"
        title="Emergency Passport Murfreesboro, TN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Murfreesboro, TN and Rutherford County — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving MTSU students, Nissan Smyrna employees, and Nashville metro professionals. No Nashville agency lines required."
        geoPlacename="Murfreesboro, Tennessee"
        geoPosition="35.8456;-86.3903"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
      />
      <MurfreesboroHeroSection />
      <MurfreesboroStickyNav />
      <MurfreesboroProcessingTimeSection />
      <MurfreesboroLocalAreaSection />
      <MurfreesboroServicesSection />
      <MurfreesboroTravelTimingSection />
      <MurfreesboroDestinationsSection />
      <MurfreesboroTestimonialsSection />
      <MurfreesboroAcceptanceFacilitiesSection />
      <MurfreesboroComparisonSection />
      <MurfreesboroMistakesSection />
      <MurfreesboroHowItWorksSection />
      <MurfreesboroFAQSection />
      <MurfreesboroHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/murfreesboro" state="TN" />
      <MurfreesboroFinalCTA />
    </div>
  );
}